import { render, staticRenderFns } from "./SolarPlants.vue?vue&type=template&id=3d3512c1&"
import script from "./SolarPlants.vue?vue&type=script&lang=js&"
export * from "./SolarPlants.vue?vue&type=script&lang=js&"
import style0 from "./SolarPlants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports